<template>
  <div class="block">
    <div class="block_">
      <img class="swiper_img" src="@/assets/images/about/about.png" alt="Slide 1" />
    </div>
  </div>
</template>




<script>
// import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";
// import { getBannerList } from "@/apis/banner";

export default {
  data() {
    return {
      mySwiper: null,
      bannerList: [],
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>

<style scoped>
.block_ {
  margin: 0 auto;
  width: 100%;
  max-width: 1920px;
  height: 100%;;
  background-color: #ffffff;
}
.block {
  width: 100%;
  height: 100%;;
  margin-top: 80px;
  background-color: #ffffff;
}
.swiper_img {
  width: 100%;
  height: 100%;;
}
</style>